module.exports = __webpack_public_path__ + "static/media/5.3dda8727.jpg";